export default function StatusPill({ status }) {
  return <span className={`pl-status-pill pl-status-${status}`}>{status}</span>;
}
